// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anim-fade-in{
  animation-name:fadein
}

.anim-modal-in{
  animation-name:modalin;
  -webkit-backdrop-filter:blur(2px);
          backdrop-filter:blur(2px)
}

.anim-slide-in{
  animation-name:slidein
}

.anim-slide-out{
  animation-name:slideout
}

.anim-pulse{
  animation-name:pulse
}

.anim-fade-out{
  animation-name:fadeout
}

.anim-duration-200{
  animation-duration:200ms !important
}

.anim-duration-300{
  animation-duration:300ms !important
}

.anim-duration-400{
  animation-duration:400ms !important
}

.anim-duration-1000{
  animation-duration:1s !important
}

.anim-duration-2000{
  animation-duration:2s !important
}

.anim-ease-out{
  animation-timing-function:ease-out !important
}

.anim-ease-in{
  animation-timing-function:ease-in !important
}

.anim-infinite{
  animation-iteration-count:infinite
}

.anim-delay-1000{
  animation-delay:1000ms !important
}

.loading-element{
  background:linear-gradient(90deg, white, rgb(215, 221, 230), white, rgb(215, 221, 230), white);
  background-size:400% 400%;
  animation:gradient 3s linear infinite
}

.transition-duration-0{
  transition-duration:0ms !important
}

.transition-duration-200{
  transition-duration:200ms !important
}

.transition-duration-100{
  transition-duration:200ms !important
}

.transition-linear{
  transition-timing-function:linear
}

.transition-all{
  transition:all
}

@keyframes gradient{
  0%{
    background-position:0% 0%
  }

  100%{
    background-position:200% 200%
  }
}

@keyframes modalin{
  0%{
    opacity:0;
    -webkit-backdrop-filter:none;
            backdrop-filter:none
  }

  99%{
    opacity:1;
    -webkit-backdrop-filter:none;
            backdrop-filter:none
  }

  100%{
    opacity:1;
    -webkit-backdrop-filter:blur(2px);
            backdrop-filter:blur(2px)
  }
}

@keyframes fadein{
  0%{
    opacity:0;
    -webkit-backdrop-filter:blur(10px);
            backdrop-filter:blur(10px)
  }

  100%{
    opacity:1;
    -webkit-backdrop-filter:blur(10px);
            backdrop-filter:blur(10px)
  }
}

@keyframes slidein{
  from{
    transform:translateY(-50%)
  }

  to{
    transform:translateY(0%)
  }
}

@keyframes slideout{
  from{
    transform:translateY(0%);
    opacity:1
  }

  to{
    transform:translateY(-50%);
    opacity:.5
  }
}

@keyframes fadeout{
  from{
    opacity:1
  }

  to{
    opacity:0
  }
}

.exome-depth{
  font-size:11px !important
}

.exome-depth .band.gneg{
  fill:#fff
}

.exome-depth .band.acen{
  fill:#f8a5a5
}

.exome-depth .band.gpos{
  fill:#6d6879
}

.exome-depth .band.stalk{
  fill:url(#stalk)
}

.exome-depth .band.gvar{
  fill:url(#gvar)
}

.exome-depth .arm-outline{
  stroke:#6d6879;
  fill:rgba(0,0,0,0);
  stroke-width:1px;
  opacity:.3
}

.exome-depth .cnv-label{
  font-size:11px !important;
  text-anchor:middle;
  fill:#6d6879
}

.exome-depth .gene-label{
  font-size:9px !important;
  transform:translateY(-0.15em);
  fill:#634170
}

.exome-depth .domain,.exome-depth .tick line{
  stroke:#6d6879;
  opacity:.1;
  stroke-width:1;
  pointer-events:none
}

.exome-depth .tick text{
  fill:#6d6879;
  opacity:.8;
  font-size:9px !important
}

.exome-depth .gene{
  fill:#634170
}

.exome-depth .gene-full{
  fill:#634170
}

.exome-depth .exon,.exome-depth .exon-label{
  fill:#634170;
  font-size:8px !important
}

.exome-depth .gene-line{
  stroke:#634170;
  opacity:.4;
  fill:rgba(0,0,0,0)
}

.exome-depth .coverage-line{
  stroke:rgba(126,126,182,.5);
  stroke-width:1px;
  pointer-events:stroke;
  fill:rgba(0,0,0,0);
  cursor:pointer
}

.exome-depth .coverage-line.main{
  stroke:#ff0036
}

.exome-depth .gene-container{
  transform-origin:left top
}

.exome-depth .brush .selection{
  opacity:0
}

.exome-depth .fake-brush{
  fill:rgba(110,110,138,.25);
  stroke:rbga(20, 20, 40, 0.6);
  transform:scaleY(1.3)
}

.exome-depth .shadow-area{
  fill:rgba(20,0,80,.1);
  background-color:rgba(20,0,80,.1);
  stroke:rgba(0,0,0,0)
}

.exome-depth .call-bar{
  fill:#ff0036;
  transform-box:fill-box;
  transition:transform .1s linear opacity .1s linear
}

.exome-depth .call-area{
  fill:#ff0036;
  background-color:rgba(255,0,54,.09);
  fill-opacity:.09;
  stroke-width:0px
}

.exome-depth .call-area:hover{
  fill:#ff0036;
  stroke:#ff0036;
  stroke-width:1px !important;
  fill-opacity:.11 !important
}

.exome-depth .call-bar:hover{
  transform-origin:center;
  transform:scale(1.1);
  cursor:pointer
}

.exome-depth .vertical-label{
  opacity:65%
}

.exome-depth .xcoord{
  opacity:.5;
  fill:#6d6879
}

.light.themed .bg-1,.dark.themed .contrast .bg-1{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255, 255, 255, var(--bg-opacity))
}

.light.themed .bg-2,.dark.themed .contrast .bg-2{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241, 245, 249, var(--bg-opacity))
}

.light.themed .bg-3,.dark.themed .contrast .bg-3{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226, 232, 240, var(--bg-opacity))
}

.light.themed .bg-4,.dark.themed .contrast .bg-4{
  --bg-opacity:1;
  background-color:#cbd5e1;
  background-color:rgba(203, 213, 225, var(--bg-opacity))
}

.light.themed .bg-4,.dark.themed .contrast .bg-4{
  --bg-opacity:1;
  background-color:#94a3b8;
  background-color:rgba(148, 163, 184, var(--bg-opacity))
}

.light.themed .color-1,.dark.themed .contrast .color-1{
  --text-opacity:1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-2,.dark.themed .contrast .color-2{
  --text-opacity:1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-3,.dark.themed .contrast .color-3{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100, 116, 139, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-4,.dark.themed .contrast .color-4{
  --text-opacity:1;
  color:#475569;
  color:rgba(71, 85, 105, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-5,.dark.themed .contrast .color-5{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100, 116, 139, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-highlight,.dark.themed .contrast .color-highlight{
  --text-opacity:1;
  color:#0284c7;
  color:rgba(2, 132, 199, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.light.themed .color-danger,.dark.themed .contrast .color-danger{
  --text-opacity:1;
  color:#dc2626;
  color:rgba(220, 38, 38, var(--text-opacity))
}

.light.themed .border-1,.dark.themed .contrast .border-1{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226, 232, 240, var(--border-opacity))
}

.light.themed .border-2,.dark.themed .contrast .border-2{
  --border-opacity:1;
  border-color:#cbd5e1;
  border-color:rgba(203, 213, 225, var(--border-opacity))
}

.light.themed .border-contrast,.dark.themed .contrast .border-contrast{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100, 116, 139, var(--border-opacity))
}

.light.themed .shadow-2xl,.dark.themed .contrast .shadow-2xl{
  box-shadow:0 25px 50px -12px rgba(0,0,0,.45)
}

.light.themed .shadow-inner-xl,.dark.themed .contrast .shadow-inner-xl{
  box-shadow:-10px 5px 17px -9px rgba(0,0,0,.1) inset
}

.light.themed .bg-grad-vert-1,.dark.themed .contrast .bg-grad-vert-1{
  background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, white 100%)
}

.light.themed .mix-blend,.dark.themed .contrast .mix-blend{
  mix-blend-mode:multiply
}

.dark.themed .bg-1,.light.themed .contrast .bg-1{
  background-color:#161219;
  fill:#161219
}

.dark.themed .bg-2,.light.themed .contrast .bg-2{
  background-color:#211b25
}

.dark.themed .bg-3,.light.themed .contrast .bg-3{
  background-color:#2b2430
}

.dark.themed .bg-4,.light.themed .contrast .bg-4{
  background-color:#362c3c
}

.dark.themed .bg-5,.light.themed .contrast .bg-5{
  background-color:#46394e
}

.dark.themed .color-1,.light.themed .contrast .color-1{
  color:#fff;
  fill:#fff;
  stroke:#fff
}

.dark.themed .color-2,.light.themed .contrast .color-2{
  color:#f5f5f5;
  fill:#f5f5f5;
  stroke:#f5f5f5
}

.dark.themed .color-3,.light.themed .contrast .color-3{
  color:#e6e6e6;
  fill:#e6e6e6;
  stroke:#e6e6e6
}

.dark.themed .color-highlight,.light.themed .contrast .color-highlight{
  --text-opacity:1;
  color:#0ea5e9;
  color:rgba(14, 165, 233, var(--text-opacity));
  fill:currentColor;
  stroke:currentColor
}

.dark.themed .color-danger,.light.themed .contrast .color-danger{
  --text-opacity:1;
  color:#f87171;
  color:rgba(248, 113, 113, var(--text-opacity))
}

.dark.themed .border-1,.light.themed .contrast .border-1{
  border-color:#2b2430
}

.dark.themed .border-2,.light.themed .contrast .border-2{
  border-color:#362c3c
}

.dark.themed .border-contrast,.light.themed .contrast .border-contrast{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity))
}

.dark.themed .shadow-2xl,.light.themed .contrast .shadow-2xl{
  box-shadow:0 25px 50px -12px #000
}

.dark.themed .shadow-inner-xl,.light.themed .contrast .shadow-inner-xl{
  box-shadow:-10px 5px 17px -9px #000 inset
}

.dark.themed .bg-grad-vert-1,.light.themed .contrast .bg-grad-vert-1{
  background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #161219 100%)
}

.dark.themed .mix-blend,.light.themed .contrast .mix-blend{
  mix-blend-mode:screen
}

.graph-container .chr-bands .gneg{
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  fill:currentColor
}

.graph-container .chr-bands .acen{
  --text-opacity:1;
  color:#ef4444;
  color:rgba(239, 68, 68, var(--text-opacity));
  fill:currentColor
}

.graph-container .chr-bands .gpos{
  fill:currentColor;
  --text-opacity:1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity))
}

.graph-container .chr-bands .stalk{
  fill:url(#stalk)
}

.graph-container .chr-bands .gvar{
  fill:url(#gvar)
}

.graph-container .chr-bands .band:hover{
  cursor:pointer
}

.graph-container .scrollbar{
  transition-duration:400ms;
  transform:translateX(1px) scaleX(0.8);
  opacity:0.5;
  transition-property:all;
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255, 255, 255, var(--bg-opacity));
  --bg-opacity:0.75;
  border-left-width:1px;
  position:absolute;
  top:0px;
  right:0px;
  bottom:0px;
  width:16px
}

.graph-container .scrollbar.panning,.graph-container .scrollbar:hover{
  opacity:1;
  box-shadow:inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  transform:scaleX(1)
}

.graph-container .brush *{
  cursor:default !important
}`, "",{"version":3,"sources":["webpack://./src/scss/_animations.scss","webpack://./src/scss/_exome-depth.scss","webpack://./src/scss/_themes.scss","<no source>","webpack://./src/scss/_genome_browser.scss"],"names":[],"mappings":"AAAA;EACE;AAAA;;AAGF;EACE,sBAAA;EACA,iCAAA;UAAA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,8FAAA;EAQA,yBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;IACE;EAAA;;EAEF;IACE;EAAA;AAAA;;AAIJ;EACE;IACE,SAAA;IACA,4BAAA;YAAA;EAAA;;EAEF;IACE,SAAA;IACA,4BAAA;YAAA;EAAA;;EAEF;IACE,SAAA;IACA,iCAAA;YAAA;EAAA;AAAA;;AAIJ;EACE;IACE,SAAA;IACA,kCAAA;YAAA;EAAA;;EAEF;IACE,SAAA;IACA,kCAAA;YAAA;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;;EAEF;IACE;EAAA;AAAA;;AAIJ;EACE;IACE,wBAAA;IACA;EAAA;;EAEF;IACE,0BAAA;IACA;EAAA;AAAA;;AAIJ;EACE;IACE;EAAA;;EAEF;IACE;EAAA;AAAA;;AC1JJ;EAKE;AAAA;;AAEA;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAbK;;AAgBP;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,cAzBK;EA0BL,kBAAA;EACA,gBAAA;EACA;AAAA;;AAGF;EACE,yBAAA;EACA,kBAAA;EACA;AAlCK;;AAoCP;EACE,wBAAA;EACA,6BAAA;EACA;AAxCK;;AA2CP;EAEE,cA5CK;EA6CL,UAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,YAnDK;EAoDL,UAAA;EACA;AAAA;;AAGF;EACE;AA1DK;;AA6DP;EACE;AA9DK;;AAiEP;EAEE,YAnEK;EAoEL;AAAA;;AAGF;EACE,cAxEK;EAyEL,UAAA;EACA;AAAA;;AAGF;EACE,2BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA;AAAA;;AAGF;EACE;AAvFI;;AA0FN;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,0BAAA;EACA,4BAAA;EACA;AAAA;;AAGF;EACE,qBAAA;EACA,iCAAA;EACA;AAAA;;AAGF;EACE,YA/GI;EAgHJ,sBAAA;EACA;AAAA;;AAGF;EACE,YArHI;EAsHJ,mCAAA;EACA,gBAAA;EACA;AAAA;;AAGF;EACE,YA5HI;EA6HJ,cA7HI;EA8HJ,2BAAA;EACA;AAAA;;AAGF;EACE,uBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,UAAA;EACA;AA5IK;;ACGP;ECNF,eAAA;EAAA,sBAAA;EAAA;ADOI;;AAEF;ECTF,eAAA;EAAA,yBAAA;EAAA;ADUI;;AAEF;ECZF,eAAA;EAAA,yBAAA;EAAA;ADaI;;AAEF;ECfF,eAAA;EAAA,yBAAA;EAAA;ADgBI;;AAEF;EClBF,eAAA;EAAA,yBAAA;EAAA;ADmBI;;AAEF;ECrBF,iBAAA;EAAA,cAAA;EAAA,4CAAA;EAAA,kBAAA;EAAA;ADsBI;;AAEF;ECxBF,iBAAA;EAAA,cAAA;EAAA,4CAAA;EAAA,kBAAA;EAAA;ADyBI;;AAEF;EC3BF,iBAAA;EAAA,cAAA;EAAA,+CAAA;EAAA,kBAAA;EAAA;AD4BI;;AAEF;EC9BF,iBAAA;EAAA,cAAA;EAAA,6CAAA;EAAA,kBAAA;EAAA;AD+BI;;AAEF;ECjCF,iBAAA;EAAA,cAAA;EAAA,+CAAA;EAAA,kBAAA;EAAA;ADkCI;;AAEF;ECpCF,iBAAA;EAAA,cAAA;EAAA,6CAAA;EAAA,kBAAA;EAAA;ADqCI;;AAEF;ECvCF,iBAAA;EAAA,cAAA;EAAA;ADwCI;;AAEF;EC1CF,mBAAA;EAAA,qBAAA;EAAA;AD2CI;;AAEF;EC7CF,mBAAA;EAAA,qBAAA;EAAA;AD8CI;;AAEF;EChDF,mBAAA;EAAA,qBAAA;EAAA;ADiDI;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAGF;EACE;AAAA;;AAEF;EACE;AAAA;;AAMF;EACE,wBApEI;EAqEJ;AArEI;;AAuEN;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAGF;EACE,UAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,YAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,YAAA;EACA;AAAA;;AAEF;ECpGF,iBAAA;EAAA,cAAA;EAAA,8CAAA;EAAA,kBAAA;EAAA;ADqGI;;AAEF;ECvGF,iBAAA;EAAA,cAAA;EAAA;ADwGI;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EChHF,mBAAA;EAAA,qBAAA;EAAA;ADiHI;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AEvHI;EDNR,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA;ACOY;;AAEJ;EDTR,iBAAA;EAAA,cAAA;EAAA,6CAAA;EAAA;ACUgB;;AAER;EDZR,kBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ACaY;;AAEJ;EACI;AAAA;;AAEJ;EACI;AAAA;;AAEJ;EACI;AAAA;;AAIR;EACI,yBAAA;EACA,qCAAA;ED5BR,YAAA;EAAA,wBAAA;EAAA,eAAA;EAAA,sBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,QAAA;EAAA,UAAA;EAAA,WAAA;EAAA;AC6BQ;;AAGJ;EDhCJ,UAAA;EAAA,iDAAA;ECkCQ;AAAA;;AAGJ;EACI;AAAA","sourcesContent":[".anim-fade-in {\n  animation-name: fadein;\n}\n\n.anim-modal-in {\n  animation-name: modalin;\n  backdrop-filter: blur(2px);\n}\n\n.anim-slide-in {\n  animation-name: slidein;\n}\n\n.anim-slide-out {\n  animation-name: slideout;\n}\n\n.anim-pulse {\n  animation-name: pulse;\n}\n\n.anim-fade-out {\n  animation-name: fadeout;\n}\n\n.anim-duration-200 {\n  animation-duration: 200ms !important;\n}\n\n.anim-duration-300 {\n  animation-duration: 300ms !important;\n}\n\n.anim-duration-400 {\n  animation-duration: 400ms !important;\n}\n\n.anim-duration-1000 {\n  animation-duration: 1s !important;\n}\n\n.anim-duration-2000 {\n  animation-duration: 2s !important;\n}\n\n.anim-ease-out {\n  animation-timing-function: ease-out !important;\n}\n\n.anim-ease-in {\n  animation-timing-function: ease-in !important;\n}\n\n.anim-infinite {\n  animation-iteration-count: infinite;\n}\n\n.anim-delay-1000 {\n  animation-delay: 1000ms !important;\n}\n\n.loading-element {\n  background: linear-gradient(\n    90deg,\n    white,\n    rgb(215, 221, 230),\n    white,\n    rgb(215, 221, 230),\n    white\n  );\n  background-size: 400% 400%;\n  animation: gradient 3s linear infinite;\n}\n\n.transition-duration-0 {\n  transition-duration: 0ms !important;\n}\n\n.transition-duration-200 {\n  transition-duration: 200ms !important;\n}\n\n.transition-duration-100 {\n  transition-duration: 200ms !important;\n}\n\n.transition-linear {\n  transition-timing-function: linear;\n}\n\n.transition-all {\n  transition: all;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 0%;\n  }\n  100% {\n    background-position: 200% 200%;\n  }\n}\n\n@keyframes modalin {\n  0% {\n    opacity: 0;\n    backdrop-filter: none;\n  }\n  99% {\n    opacity: 1;\n    backdrop-filter: none;\n  }\n  100% {\n    opacity: 1;\n    backdrop-filter: blur(2px);\n  }\n}\n\n@keyframes fadein {\n  0% {\n    opacity: 0;\n    backdrop-filter: blur(10px);\n  }\n  100% {\n    opacity: 1;\n    backdrop-filter: blur(10px);\n  }\n}\n\n@keyframes slidein {\n  from {\n    transform: translateY(-50%);\n  }\n  to {\n    transform: translateY(0%);\n  }\n}\n\n@keyframes slideout {\n  from {\n    transform: translateY(0%);\n    opacity: 1;\n  }\n  to {\n    transform: translateY(-50%);\n    opacity: 0.5;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n",".exome-depth {\n  $red: rgb(255, 0, 54);\n  $gene: #634170;\n  $band: #6d6879;\n\n  font-size: 11px !important;\n\n  .band.gneg {\n    fill: white;\n  }\n\n  .band.acen {\n    fill: rgb(248, 165, 165);\n  }\n\n  .band.gpos {\n    fill: $band;\n  }\n\n  .band.stalk {\n    fill: url(#stalk);\n  }\n\n  .band.gvar {\n    fill: url(#gvar);\n  }\n\n  .arm-outline {\n    stroke: $band;\n    fill: transparent;\n    stroke-width: 1px;\n    opacity: 0.3;\n  }\n\n  .cnv-label {\n    font-size: 11px !important;\n    text-anchor: middle;\n    fill: $band;\n  }\n  .gene-label {\n    font-size: 9px !important;\n    transform: translateY(-0.15em);\n    fill: $gene;\n  }\n\n  .domain,\n  .tick line {\n    stroke: $band;\n    opacity: 0.1;\n    stroke-width: 1;\n    pointer-events: none;\n  }\n\n  .tick text {\n    fill: $band;\n    opacity: 0.8;\n    font-size: 9px !important;\n  }\n\n  .gene {\n    fill: $gene;\n  }\n\n  .gene-full {\n    fill: $gene;\n  }\n\n  .exon,\n  .exon-label {\n    fill: $gene;\n    font-size: 8px !important;\n  }\n\n  .gene-line {\n    stroke: $gene;\n    opacity: 0.4;\n    fill: transparent;\n  }\n\n  .coverage-line {\n    stroke: rgba(126, 126, 182, 0.5);\n    stroke-width: 1px;\n    pointer-events: stroke;\n    fill: transparent;\n    cursor: pointer;\n  }\n\n  .coverage-line.main {\n    stroke: $red;\n  }\n\n  .gene-container {\n    transform-origin: left top;\n  }\n\n  .brush .selection {\n    opacity: 0;\n  }\n\n  .fake-brush {\n    fill: rgba(110, 110, 138, 0.25);\n    stroke: rbga(20, 20, 40, 0.6);\n    transform: scaleY(1.3);\n  }\n\n  .shadow-area {\n    fill: rgba(20, 0, 80, 0.1);\n    background-color: rgba(20, 0, 80, 0.1);\n    stroke: transparent;\n  }\n\n  .call-bar {\n    fill: $red;\n    transform-box: fill-box;\n    transition: transform 0.1s linear opacity 0.1s linear;\n  }\n\n  .call-area {\n    fill: $red;\n    background-color: rgba($red, 0.09);\n    fill-opacity: 0.09;\n    stroke-width: 0px;\n  }\n\n  .call-area:hover {\n    fill: $red;\n    stroke: $red;\n    stroke-width: 1px !important;\n    fill-opacity: 0.11 !important;\n  }\n\n  .call-bar:hover {\n    transform-origin: center;\n    transform: scale(1.1);\n    cursor: pointer;\n  }\n\n  .vertical-label {\n    opacity: 65%;\n  }\n\n  .xcoord {\n    opacity: 0.5;\n    fill: $band;\n  }\n}\n","$dark: rgb(17, 14, 19);\n$dark1: lighten($dark, 2%);\n$light: white;\n\n.light.themed,\n.dark.themed .contrast {\n  .bg-1 {\n    @apply tw-bg-white;\n  }\n  .bg-2 {\n    @apply tw-bg-blueGray-100;\n  }\n  .bg-3 {\n    @apply tw-bg-blueGray-200;\n  }\n  .bg-4 {\n    @apply tw-bg-blueGray-300;\n  }\n  .bg-4 {\n    @apply tw-bg-blueGray-400;\n  }\n  .color-1 {\n    @apply tw-text-blueGray-900 tw-fill-current tw-stroke-current;\n  }\n  .color-2 {\n    @apply tw-text-blueGray-700 tw-fill-current tw-stroke-current;\n  }\n  .color-3 {\n    @apply tw-text-blueGray-500 tw-fill-current tw-stroke-current;\n  }\n  .color-4 {\n    @apply tw-text-blueGray-600 tw-fill-current tw-stroke-current;\n  }\n  .color-5 {\n    @apply tw-text-blueGray-500 tw-fill-current tw-stroke-current;\n  }\n  .color-highlight {\n    @apply tw-text-sky-600 tw-fill-current tw-stroke-current;\n  }\n  .color-danger {\n    @apply tw-text-red-600;\n  }\n  .border-1 {\n    @apply tw-border-blueGray-200;\n  }\n  .border-2 {\n    @apply tw-border-blueGray-300;\n  }\n  .border-contrast {\n    @apply tw-border-blueGray-500;\n  }\n  .shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);\n  }\n  .shadow-inner-xl {\n    box-shadow: -10px 5px 17px -9px rgba(0, 0, 0, 0.1) inset;\n    // box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.5);\n  }\n  .bg-grad-vert-1 {\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, $light 100%);\n  }\n  .mix-blend {\n    mix-blend-mode: multiply;\n  }\n}\n\n.dark.themed,\n.light.themed .contrast {\n  .bg-1 {\n    background-color: $dark1;\n    fill: $dark1;\n  }\n  .bg-2 {\n    background-color: lighten($dark, 6%);\n  }\n  .bg-3 {\n    background-color: lighten($dark, 10%);\n  }\n  .bg-4 {\n    background-color: lighten($dark, 14%);\n  }\n  .bg-5 {\n    background-color: lighten($dark, 20%);\n  }\n\n  .color-1 {\n    color: darken($light, 0%);\n    fill: darken($light, 0%);\n    stroke: darken($light, 0%);\n  }\n  .color-2 {\n    color: darken($light, 4%);\n    fill: darken($light, 4%);\n    stroke: darken($light, 4%);\n  }\n  .color-3 {\n    color: darken($light, 10%);\n    fill: darken($light, 10%);\n    stroke: darken($light, 10%);\n  }\n  .color-highlight {\n    @apply tw-text-sky-500 tw-fill-current tw-stroke-current;\n  }\n  .color-danger {\n    @apply tw-text-red-400;\n  }\n  .border-1 {\n    border-color: lighten($dark, 10%);\n  }\n  .border-2 {\n    border-color: lighten($dark, 14%);\n  }\n  .border-contrast {\n    @apply tw-border-blueGray-400;\n  }\n  .shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 1);\n  }\n  .shadow-inner-xl {\n    box-shadow: -10px 5px 17px -9px rgba(0, 0, 0, 1) inset;\n  }\n  .bg-grad-vert-1 {\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, $dark1 100%);\n  }\n  .mix-blend {\n    mix-blend-mode: screen;\n  }\n}\n",null,"\n\n\n.graph-container {\n\n    .chr-bands {\n        .gneg {\n            @apply tw-text-white tw-fill-current; \n        }\n        .acen {\n                @apply tw-text-red-500 tw-fill-current;\n        }  \n        .gpos {\n            @apply tw-fill-current tw-text-blueGray-900 \n        }\n        .stalk {\n            fill: url(#stalk);\n        }\n        .gvar {\n            fill: url(#gvar);\n        }\n        .band:hover{\n            cursor: pointer;\n        }\n    }\n\n    .scrollbar {\n        transition-duration: 400ms;\n        transform: translateX(1px) scaleX(0.8);\n        @apply tw-opacity-50 tw-transition-all tw-bg-white tw-bg-opacity-75 tw-border-l tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-w-4; \n    }\n    \n    .scrollbar.panning, .scrollbar:hover  {\n        @apply tw-opacity-100 tw-shadow-inner;\n        transform: scaleX(1);\n    }\n    \n    .brush * {\n        cursor: default !important;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
